import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["element", "input"];
  static values = {
    bindInputId: String,
    visibleOn: String,
    visibleOnList: Array,
  };

  connect() {
    const bindingInput = document.getElementById(this.bindInputIdValue);
    this._manageElementDisplay(bindingInput.value);

    bindingInput.addEventListener("input", () => {
      this._manageElementDisplay(bindingInput.value);
    });
  }

  _manageElementDisplay(bindInputValue) {
    if (this._isValueMatched(bindInputValue)) {
      this._showElement();
    } else {
      this._hideElement();
    }
  }

  _isValueMatched(inputValue) {
    if (this.hasVisibleOnListValue) {
      return this.visibleOnListValue.includes(inputValue);
    }

    return this.visibleOnValue === inputValue;
  }

  _showElement() {
    this.elementTarget.classList.remove("hidden");
    this.inputTargets.forEach((input) => (input.disabled = false));
  }

  _hideElement() {
    this.elementTarget.classList.add("hidden");
    this.inputTargets.forEach((input) => (input.disabled = true));
  }
}
